import { useState } from 'react';
import './App.css';
import '@fontsource/roboto/500.css';
import NoticeModal from './noticemodal';

function Condition({ data }) {

  return (
    <>
    <div style={{ textAlign: 'center', padding: 16 }}>
      <hr />

      <h1 className="px-5">WORKER's AT YOUR PLACE <span className="add-color-mandate-blue"><img src="./../../../../assets/img/helper/247service.png" height={60} alt="WhatsApp" /> </span> </h1>

      <p className="big call-class">
        <img
          src="./../../../../assets/img/logo/whatsapp.png"
          height={50}
          alt="Call Icon"
          style={{ verticalAlign: 'middle', marginRight: 8 }}
        />
        Just Give a Call Prior 4 Hrs.<sup className="add-color-mandate-red" />
      </p>

      <code className="code-class">
        <h4>
          Work are subject to 8 Hours only including 40 min lunch. Beyond 8 Hrs will be Over time - 150 INR / hr.
        </h4>
      </code>

      <code className="code-refund-class">
        <h4>Work not satisfactory, 100% Advance will be refunded.</h4>
      </code>

      <hr />

      <h4>
        Small or Micro Work which takes less then 2 hrs are cap Fixed 500 INR + 300 INR Transport Charges Max.
      </h4>

      <hr />

      <div className="background">
        <h3>
          1'st Day 10% Advance Payment Are Mandatory And Are 100% Refundable if "in case".
        </h3>
      </div>

      <h5>
        2'nd Day onward's 50% Advance Payment Are Mandatory And Are 100% Refundable if "in case".
      </h5>

      {/* <h4 className='' style={{ backgroundColor: 'yellow' }}><p>We are working on to REDUCE the TRANSPORTATION COST & TIME taken to reach the site location.</p></h4> */}

      
      

    </div>
    <div className="container-fluid p-3">
      <div className="row justify-content-center">
        <img src="../../../../assets/img/process/process.png" className='img-fluid' height={800} alt="Call Icon" style={{ verticalAlign: 'middle', marginRight: 8 }} />
        </div>
    </div>
    

          <hr></hr>
          <div class="py-1">
                     
            <div class="container">

              <div class="row justify-content-center">

                {/* <div class="col-sm-4 col-md-4">

                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th scope="col" colspan="2" class="add-color-red">Regular / Traditional Service  = 9 AM to 5 PM (Lunch 40 Min)</th>
                        </tr>
                      </thead>            
                      <tbody>
                        <tr>
                          <td>Mistri</td>
                          <td>900 INR / Day</td>
                        </tr>
                        <tr>                
                          <td>Helper</td>
                          <td>700 INR / Day</td>

                        </tr>
                        <tr>                
                          <td>Heavy Labour</td>
                          <td>1200 INR / Day</td>
                        </tr>
                        <tr>                
                          <td>Painter</td>
                          <td>800 INR / Day</td>
                        </tr>
                        <tr>                
                          <td>Tiles Mistri</td>
                          <td>1500 INR / Day</td>
                        </tr>
                      </tbody>
                    </table> 
                </div> */}

                <div class="col-sm-12 col-md-12 p-5 ">                    
                    <table className="table table-sm table-responsive">
                      <thead style={{fontSize: '1.8rem', fontWeight: 'bold'}}>
                        <tr>
                          <th scope="col" colspan="4">FRAUD CUSTOMER | MENTALLY SICK | TYPICAL DEHATI | Must Be IN PRISONED.</th>
                        </tr>
                      </thead>            
                      <tbody style={{fontSize: '1.2rem', fontWeight: 'bold'}}>
                        <tr>
                          <td>Kapil & Akem</td>
                          <td>Fraud Contractor Company New Delhi</td>
                          <td>3,400/- INR</td>
                          <td>Bill Date : 21 July 2025</td>
                        </tr>
                        <tr>                
                          <td>Vandhana Sharma</td>
                          <td>Radhika Apartment 97 Dwarka</td>
                          <td>2,120/- INR</td>
                          <td>Bill Date : 7 Sep 2025</td>
                        </tr>
                        <tr>                
                          <td>Romil Dahiya</td>
                          <td>3118 C Block Green Fields Colony Faridabad</td>
                          <td>6,000/- INR</td>
                          <td>Bill Date : 5th July 2026</td>
                        </tr>                                                                  
                      </tbody>
                    </table>                    
                </div>      

                <div class="col-sm-12 col-md-12 p-5">

                    <table className="table table-sm table-responsive">
                      <thead style={{fontSize: '1.8rem', fontWeight: 'bold'}}> 
                        <tr>
                          <th scope="col" colspan="3" class="add-color-p-service">Super Fast Service ( 9 AM to 5 PM - Include Lunch 40 Min )</th>
                        </tr>
                      </thead>            
                      <tbody >
                        <tr>
                          <td class="add-color-title-service">No. of Workers</td>
                          <td class="add-color-title-service"> 1 </td>
                          <td class="add-color-title-service"> 2 </td>
                          <td class="add-color-title-service"> 4 </td>
                          <td class="add-color-title-service"> 6 </td>
                        </tr>                        
                        <tr>
                          <td><b>Mistri</b></td>
                          <td class="font-size"> 1,600 INR <span class="span-font-size">/ 8 Hrs / At your Door</span></td>
                          <td> 3,200 INR / 8 Hrs</td>
                          <td> 6,400 INR / 8 Hrs</td>
                          <td> 9,600 INR / 8 Hrs</td>
                        </tr>
                        <tr>                
                          <td><b>Helper</b></td>
                          <td> Min 2 person </td>
                          <td class="font-size"> 2,800 INR <span class="span-font-size">/ 8 Hrs / At your Door</span></td>
                          <td> 5,600 INR / 8 Hrs</td>
                          <td> 8,400 INR / 8 Hrs</td>
                        </tr>
                        <tr>                
                          <td><b>Heavy Labour</b></td>
                          <td> Min 2 Person </td>
                          <td class="font-size"> 3,600 INR <span class="span-font-size">/ 8 Hrs / At your Door</span></td>
                          <td> 7,200 INR / 8 Hrs</td>
                          <td>10,800 INR / 8 Hrs</td>
                        </tr>
                        <tr>                
                          <td><b>Painter</b></td>
                          <td class="font-size"> 1,500 INR <span class="span-font-size">/ 8 Hrs / At your Door</span></td>
                          <td> 2,900 INR / 8 Hrs</td>
                          <td> 5,600 INR / 8 Hrs</td>
                          <td> 8,400 INR / 8 Hrs</td>                          
                        </tr>
                        <tr>                
                          <td><b>Tiles Mistri</b></td>
                          <td class="font-size"> 1,800 INR <span class="span-font-size">/ 8 Hrs / At your Door</span></td>
                          <td> 3,600 INR / 8 Hrs</td>
                          <td> 7,200 INR / 8 Hrs</td>
                          <td>10,800 INR / 8 Hrs</td>
                        </tr>
                        {/* <tr>                
                          <td>Carpenter</td>
                          <td>1800 INR / Day</td>
                        </tr>                                           */}
                      </tbody>
                    </table> 
                </div>                          
              </div>
              <hr></hr>
              <p class="para-title" style={{ textAlign: 'center', padding: 16 }}>Happy Customers</p>
              <div class="row justify-content-center p 10">  
                <div class="col-sm-1 col-md-1"></div>                            
                
                <div class="col-sm-9 col-md-9"> 
                  <ul style={{ textAlign: 'left', padding: 16 }}>                    
                    <li>Dental Devices and Supplies India</li>
                    <li>MANISH KUMAR Greater Kailash</li>
                    <li>POISED INDIA advisory Private Limited</li>
                    <li>R&N Growcers LLP</li>                  
                    <li>Rakesh Sharma JK Tyre & Alignment Dwarka Mod Delhi</li>
                    <li>RK Sanitary Greater Noida UP</li>
                    <li>Maa Vaishno Groceries Acher Market Greater Noida UP</li>
                  </ul>                      
                </div>                
                <div class="col-sm-2 col-md-2"></div>                                
              </div> 

              <p class="para-title" style={{ textAlign: 'center', padding: 16 }}>Now at Greater Noida</p> 

              <div class="row justify-content-center">
                
                <div class="col-sm-2 col-md-2">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/maid.png" alt="Cook"/>
                </div>                
                <div class="col-sm-2 col-md-2">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/cleaning.png" alt="Cleaner"/>                    
                </div>                
                <div class="col-sm-2 col-md-2">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/mistri.png" alt="Mistri"/>
                </div>
                <div class="col-sm-2 col-md-2">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/heavy-labour.png" alt="Heavy Labour"/>
                </div>
                <div class="col-sm-2 col-md-2">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/gardener.png" alt="Gardener"/>
                </div>                                
                <div class="col-sm-2 col-md-2"></div>
              </div>                 

              <hr></hr>
              <div style={{ textAlign: 'center', padding: 16 }}>
                <p class="para-title py-3">Existing Labour Chowk Which Are Now Online</p>
              </div>
              <div class="row">

                <div class="col-md-4">
                  <p class="card-text">New Delhi</p>
                  <div class="card mb-4 box-shadow">
                    {/* <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-school77.jpg" alt="Card image cap"/> */}
                    <div class="card-body">
                        <p class="card-text">Delhi West  </p>
                        <p>Uttam Nagar Labour Chowk ( 39 )   </p>

                        <p>Nangloi Labour Chowk ( 45 )   </p>                      

                        <p>Sonpark Labour Chowk ( 3 )  </p>

                        <p>Najafgarh Labour Chowk( 2 )  </p>

                        <p class="card-text">Delhi South West  </p>
                        <p>Dwarka Sector 14 Labour Chowk ( 3 )  </p>

                        <p class="card-text">Delhi North West  </p>
                        <p>GTB Nagar Camp Labour Chowk ( 1 )  </p>

                        <p class="card-text">Delhi Central  </p>
                        <p>Paharganj Labour Chowk ( 1 )  </p>                      
                    </div>

                    
                  </div>
                </div>
                <div class="col-md-4">
                  <p class="card-text">Uttar Pradesh</p>
                  <div class="card mb-4 box-shadow">

                    <div class="card-body">
                        <p>Ballia </p>
                        <p>Chitu Pandey Labour Chowk ( 11 ) </p>

                        <p>Kadam Labour Chowk ( 8 ) </p>

                        <p>Bangala Labour Chowk ( 1 ) </p>                   
                      
                        <p>Geater Noida </p>
                        <p>Delta 1 Labour Chowk ( 3 ) </p>                      
                    </div>

                    
                  </div>
                </div>
                <div class="col-md-4">
                  <p class="card-text">Bihar</p>
                  <div class="card mb-4 box-shadow">
                    
                    <div class="card-body">
                        <p>
                          Buxar
                          Yamuna Labour Chowk ( 12 )
                        </p>                      
                    </div>

                  </div>
                </div>
                {/* <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    
                    <div class="card-body">
                      <p class="card-text">Madhya Pradesh</p>
                    </div>
                  </div>
                </div>                 */}
             </div>                

              <hr></hr>
              
              <div style={{ textAlign: 'center', padding: 16 }}>
                  <p class="para-title py-3">RECENT PROJECT</p>
              </div>

              

              <div class="row">

                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/dental.png" alt="Dental Service"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/metro.png" alt="Metro Service"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/diwali.jpg" alt="Diwali Service"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/sofa.jpg" alt="Sofa Service"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/paint.jpg" alt="Painting Service"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/paint1.jpg" alt="Painting Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>                

                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-school77.jpg" alt="School Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-school22.jpg" alt="School Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-school11.jpg" alt="School Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-house22.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-house33.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner-house4.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner1.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner3.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card mb-4 box-shadow">
                    <img class="card-img-top img-fluid" src="../../../../assets/img/lc-banner5.jpg" alt="House Service Men at Work"/>
                    <div class="card-body">
                      <p class="card-text"></p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>  

          <hr></hr>
          <div class="album py-5 bg-light">

            <div style={{ textAlign: 'center', padding: 16 }}>
                <p class="para-title py-3">SELL RENT</p>
                <p class="px-5">Tools &amp; Equipments on Rent</p>
                <p> <a href="https://sellrent.in" target='new'>www.sellrent.in</a> </p>
                <p class="">On Daily, Monthly, YEARLY.</p>
            </div>


            <div class="container">
              
              <div class="row p-2 justify-content-center">
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool88.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>              
                </div>                                
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool77.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>              
                </div>                
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool6.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>              
                </div>
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool5.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>              
                </div>
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool4.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>                
                </div>
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool3.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>                
                </div>
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool2.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>                
                </div>
                <div class="col-4">
                      <div class="card mb-4 box-shadow">
                        <img class="card-img-top img-fluid" src="../../../../assets/img/tool1.jpg" alt="Tools &amp; Equipments on Rent"/>
                        <div class="card-body">
                          <p class="card-text"></p>
                        </div>
                      </div>                
                </div>
                                                                                                                                                             
              </div>
            </div>
          </div>    

<section class="section bg-white">

<div class="container">

<div class="text-center mb-5">
<h2 class="fw-bold">Why Choose LabourChowk.in?</h2>
<p class="text-muted">
Designed for both workers and employers.
</p>
</div>

<div class="row g-4">

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-search text-primary fs-1"></i>
<h5 class="mt-3">Easy Search</h5>
<p class="text-muted">Find skilled workers quickly by location and trade.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-shield-check text-success fs-1"></i>
<h5 class="mt-3">Trusted Platform</h5>
<p class="text-muted">A secure and transparent hiring experience.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-clock-history text-warning fs-1"></i>
<h5 class="mt-3">Save Time</h5>
<p class="text-muted">Reduce hiring delays with faster connections.</p>
</div>
</div>

<div class="col-md-3">
<div class="value-card">
<i class="bi bi-people-fill text-danger fs-1"></i>
<h5 class="mt-3">Community</h5>
<p class="text-muted">Building opportunities for workers and employers.</p>
</div>
</div>

</div>

</div>

</section>


<section class="section stats">

<div class="container">

<div class="row text-center">

<div class="col-md-3">
<div class="stat-number">90+</div>
<p>Registered Workers</p>
</div>

<div class="col-md-3">
<div class="stat-number">50+</div>
<p>Employers</p>
</div>

<div class="col-md-3">
<div class="stat-number">80+</div>
<p>Skilled & Unskilled Mens</p>
</div>

<div class="col-md-3">
<div class="stat-number">24×7</div>
<p>Online Platform</p>
</div>

</div>

</div>

</section>


<section class="section">

<div class="container">

<div class="text-center mb-5">
<h2 class="fw-bold">Our Core Values</h2>
</div>

<div class="row g-4">

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-heart-fill text-danger fs-1"></i>
<h4 class="mt-3">Trust</h4>
<p class="text-muted">
Building confidence between workers and employers.
</p>
</div>
</div>

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-lightbulb-fill text-warning fs-1"></i>
<h4 class="mt-3">Innovation</h4>
<p class="text-muted">
Using technology to simplify hiring and job discovery.
</p>
</div>
</div>

<div class="col-md-4">
<div class="card-modern p-4 text-center">
<i class="bi bi-award-fill text-primary fs-1"></i>
<h4 class="mt-3">Quality</h4>
<p class="text-muted">
Delivering reliable services and meaningful opportunities.
</p>
</div>
</div>

</div>

</div>

</section>


<section class="footer-cta">

<div class="container">

<h2>Building India's Digital Labour Marketplace</h2>

<p class="lead mt-3">
Connecting skilled workers with opportunities and helping employers hire
with confidence.
</p>

<a href="#" class="btn btn-warning btn-lg mt-3 px-5">
Join LabourChowk.in
</a>

</div>

</section>

<NoticeModal></NoticeModal>

{/* <div class="modal fade" id="NoteModalCenter" style={{ display: "block" }} tabindex="-1" role="dialog" aria-labelledby="noteModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" show="true" >
      <div class="modal-header ">
        <h5 class="modal-title" id="exampleModalLongTitle">:: IMPORTANT NOTE ::</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body code">
        <h2>We are NOT :-</h2>
        <ul>
          <li>SUPERVISOR,</li>
          <li>THEKEDAR,</li>
          <li>RESPONSIBLE FOR THE QUALITY OF WORK,</li>
          <li>NOT RESPONSIBLE FOR THE COMPLETION OF WORK.</li>          
        </ul>
        <h2>We are :-</h2>
        <ul>
          <li>PEOPLE PROVIDER</li>
          <li>MEN POWER PROVIDER</li>
          <li>LABOUR WORKER HELPER PROVIDER</li>
          <li>SKILL AND TALENT MATCHING PLATFORM</li>
          
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>    
      </div>
    </div>
  </div>
</div> */}

<div class="sidebarBox">
  <div class="justify-content-center">
      {/* <p>Please use below QR for all Payments.</p> */}
      <img src="../../../../assets/img/donation.jpg" className='img-fluid' alt='QR Code for Payments' width="25%"></img>
  </div>
</div>

  
    </>
  );
}

export default Condition;


